<template>
<div class="chapter">
<div class="inner_page">
<h2 id="_idParaDest-2">Contents</h2>
<p class="firstleft"><a href="#/Text/preface">Preface</a></p>
<p class="firstleft"><a href="#/Text/pt1"><b>PART 1: Critical Contexts</b></a></p>
<p class="body_sa"><a href="#/Text/ch1">1 Introduction: Religion and the Discourse of Modernism</a></p>
<p class="body_sa"><a href="#/Text/ch2">2 H. R. Rookmaaker, <i>Modern Art and the Death of a Culture</i></a></p>
<p class="firstleft"><span href="#/Text/pt2" title="Link target outside of Sample"><b>PART 2: Geographies, Histories and Encounters</b></span></p>
<p class="body_sa"><span href="#/Text/ch3" title="Link target outside of Sample">3 France, Britain and the Sacramental Image</span></p>
<p class="body_sa"><span href="#/Text/ch4" title="Link target outside of Sample">4 Germany, Holland and Northern Romantic Theology</span></p>
<p class="body_sa"><span href="#/Text/ch5" title="Link target outside of Sample">5 Russian Icons, Dada Liturgies and Rumors of Nihilism</span></p>
<p class="body_sa"><span href="#/Text/ch6" title="Link target outside of Sample">6 North America and the Expressive Image</span></p>
<p class="body_sa"><span href="#/Text/ch7" title="Link target outside of Sample">7 North America in the Age of Mass Media</span></p>
<p class="firstleft"><span href="#/Text/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="firstleft"><span href="#/Text/afterword" title="Link target outside of Sample">Afterword: So What? by Daniel A. Siedell</span></p>
<p class="firstleft"><span href="#/Text/bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="firstleft"><span href="#/Text/illustrations" title="Link target outside of Sample"><i>Illustrations</i></span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="firstleft"><span href="#/Text/generalindex" title="Link target outside of Sample"><i>General Index</i></span></p>
<p class="firstleft"><span href="#/Text/scriptureindex" title="Link target outside of Sample"><i>Scripture Index</i></span></p>
<p class="firstleft"><span href="#/Text/praise" title="Link target outside of Sample"><i>Praise for</i> Modern Art and the Life of a Culture</span></p>
<p class="firstleft"><span href="#/Text/authors" title="Link target outside of Sample"><i>About the Authors</i></span></p>
<p class="firstleft"><span href="#/Text/brandpage" title="Link target outside of Sample"><i>Studies in Theology and the Arts</i></span></p>
<p class="firstleft"><span href="#/Text/moreIVP" title="Link target outside of Sample"><i>More Titles from InterVarsity Press</i></span></p>
<p class="firstleft"><span href="#/Text/copyright" title="Link target outside of Sample"><i>Copyright</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4f759590